import { DeterministicView } from '@bingads-webui/deterministic-view';
import template from './search-template.pug';

export class Search extends DeterministicView {
  initialize({
    placeholder = 'account name',
    searchResultsId = 'search-results',
  }) {
    this.placeholder = placeholder;
    this.searchResultsId = searchResultsId;
  }

  events() {
    return {
      'click .dropdown-search-selector__search--submit': () => this.search(),
      'input input#srch-term': () => this.onChange(),
      keypress: e => this.keyPress(e),
    };
  }

  keyPress(e) {
    if (e.keyCode === 13) {
      e.preventDefault();
      this.search();
    }
  }

  onChange() {
    this.trigger('searchChanged', this.$('#srch-term')[0].value);
  }

  search() {
    this.trigger('searchInvoked', this.$('#srch-term')[0].value);
  }

  get template() {
    return template;
  }
}
